import React, { useEffect, useState } from "react";
import Select from "react-select";
import { X } from "react-feather";
import { apiService } from "../../../../services/apiService.ts";

export default function AddTabModal({
  isOpen,
  onClose,
  costCenter,
  staff,
  onSave
}) {
  const [accounts, setAccounts] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const [form, setForm] = useState({
    FK_StaffID: null,
    FK_AccountID: null,
    FK_CostCenterID: null,
    NoOfGuests: "",
    TabName: "",
    TableNumber: ""
  });

  // Load accounts
  useEffect(() => {
    if (!isOpen) return;

    apiService.getAccounts().then((res) => {
      setAccounts(
        (res?.Data || []).map((a) => ({
          value: a.AccountID,
          label: a.Name?.trim() || "(Unnamed Account)",
          guestCount: a.GuestCount ?? 0,
          raw: a
        }))
      );

    });
  }, [isOpen]);

  // Prefill IDs
  useEffect(() => {
    if (!isOpen) return;

    setForm((f) => ({
      ...f,
      FK_StaffID: staff?.StaffID || null,
      FK_CostCenterID: costCenter?.CostCenterID || null
    }));

    setErrorMessage("");
  }, [isOpen, staff, costCenter]);

  if (!isOpen) return null;

  const update = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const result = await onSave(form);
    if (!result) {
      setErrorMessage("Failed to create tab. Please try again.");
    }
  };

  return (
    <>
      {/* Optional dim background (but not a modal overlay) */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.35)",
          zIndex: 50000
        }}
        onClick={onClose}
      />

      {/* CENTERED FLOATING CARD */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#ffffff",
          zIndex: 50001,
          borderRadius: "14px",
          padding: "26px 28px",
          width: "400px",
          boxShadow: "0 12px 28px rgba(0,0,0,0.3)"
        }}
      >
        {/* Close button — matching TabSelectModal */}
        <button
          className="btn btn-light"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            borderRadius: "10px",
            padding: "6px 10px"
          }}
        >
          <X size={18} />
        </button>

        <h4 className="mb-3 text-center">Create New Tab</h4>

        {errorMessage && (
          <div className="alert alert-danger py-2 text-center">
            {errorMessage}
          </div>
        )}

        {/* Account */}
        <div className="input-block mb-3">
          <label className="fw-semibold">Account</label>
          <Select
            classNamePrefix="react-select"
            options={accounts}
            placeholder="Select account"
            onChange={(selected) => {
              update("FK_AccountID", selected.value);

              // Auto-fill tab name
              if (selected.label && selected.label !== "(Unnamed Account)") {
                update("TabName", selected.label);
              }

              // Auto-fill guest count from account
              update("NoOfGuests", selected.guestCount ?? 0);
            }}

          />

        </div>

        {/* Tab Name */}
        <div className="input-block mb-3">
          <label className="fw-semibold">Tab Name</label>
          <input
            className="form-control"
            type="text"
            value={form.TabName}
            onChange={(e) => update("TabName", e.target.value)}
            placeholder="Enter name"
          />
        </div>

        {/* Table Number */}
        <div className="input-block mb-3">
          <label className="fw-semibold">Table Number</label>
          <input
            className="form-control"
            type="number"
            value={form.TableNumber}
            onChange={(e) => update("TableNumber", e.target.value)}
            placeholder="0"
          />
        </div>

        {/* Guests */}
        <div className="input-block mb-3">
          <label className="fw-semibold">No. of Guests</label>
          <input
            className="form-control"
            type="number"
            value={form.NoOfGuests}
            onChange={(e) => update("NoOfGuests", e.target.value)}
            placeholder="0"
          />
        </div>

        {/* Submit */}
        <button className="btn btn-success w-100" onClick={handleSubmit}>
          Create Tab
        </button>
      </div>
    </>
  );
}
